module.exports = __webpack_public_path__ + "img/vip-head-icon.94b145b2.png";